import type { Map as MapboxMap } from "mapbox-gl";

/**
 * True once the style JSON has loaded, which is all addSource/addLayer need
 * (they throw "Style is not done loading" only before then). Not
 * `isStyleLoaded()`: that also waits for every source's tiles, and while the
 * fire animation's canvas source (`animate: true`) keeps the map repainting
 * the `idle` that would end that wait never fires. `_loaded` is set just
 * before `style.load` fires.
 */
export const isStyleParsed = (map: MapboxMap): boolean => !!map.style?._loaded;

/** Runs `fn` once the style has loaded: now, or on `style.load`. Returns a
 *  function that cancels a call still waiting. */
export const onStyleReady = (map: MapboxMap, fn: () => void): (() => void) => {
  if (isStyleParsed(map)) {
    fn();
    return () => {};
  }
  const ready = () => {
    if (!isStyleParsed(map)) return;
    map.off("style.load", ready);
    fn();
  };
  map.on("style.load", ready);
  return () => {
    map.off("style.load", ready);
  };
};
